<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.home.Registro_controladores') }}</span>
            <div class="sixteen wide column" v-if="isAdmin">
              <router-link class="item" to="/newTerminal">
                <div class="ui small olive labeled icon button" style="float: right; bottom: -34px;">
                  <i class="add icon"></i>{{ $t("components.registeredTerminals.Registrar_nuevo") }}
                </div>
              </router-link>
              <div class="ui small olive labeled icon button" style="float: right; bottom: -34px;" @click="doAccessAllTerminalsToAllUsers">
                <i class="check icon"></i> {{ $t('components.registeredTerminals.Permisos_todos_terminales_todos_usuarios') }}
              </div>
            </div>
          </div>
          <h3 class="ui dividing header">{{ $t("components.registeredTerminals.Listado_de_dispositivos") }}</h3>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <RegisteredTerminals></RegisteredTerminals>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RegisteredTerminals from '@/components/RegisteredTerminals.vue';
import axios from '../../utils/axios-general';

export default {
  name: 'Terminals',
  components: {
    RegisteredTerminals
  },
  computed: {
    isAdmin: function() {
      return this.$store.state.user.role === 0;
    },
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  },
  methods: {
    doAccessAllTerminalsToAllUsers: function () {
      this.$swal.fire({
        title: this.$i18n.t('components.registeredTerminals.Esta_seguro'),
        text: this.$i18n.t('components.registeredTerminals.Se_asignaran_todos_terminales_todos_usuarios'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$i18n.t('components.common.Si'),
        cancelButtonText: this.$i18n.t('components.common.No')
      }).then((result) => {
        if (result.value) {
          this.$swal.fire({
            title: this.$i18n.t('components.registeredTerminals.Enviando_operacion'),
            timer: 0,
            timerProgressBar: true,
            showConfirmButton: false,
            type: 'info',
            onBeforeOpen: () => {
              this.$swal.showLoading();
            }
          });

          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.post('/controller/allControllersAllUsers').then(response => {
            this.$swal.close();
            this.$swal.fire(
              this.$i18n.t('components.registeredTerminals.Permisos_creados'),
              this.$i18n.t('components.registeredTerminals.Todos_permisos_creados'),
              'success'
            );
          }).catch(e => {
            this.$swal.close();
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.common.Error'),
              text: e
            });
          });
        }
      });
    },
  }
};
</script>
